/** Leave contracts — spec §6.22, §7.7c, F23. */
import { z } from 'zod';
import { LEAVE_STATUSES, LEAVE_TYPES } from './enums.js';
import { csvOf, objectIdSchema } from './common.js';
export const createLeaveSchema = z
    .object({
    type: z.enum(LEAVE_TYPES),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    reason: z.string().max(500).optional(),
})
    .strict()
    .superRefine((val, ctx) => {
    if (val.endDate < val.startDate) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['endDate'],
            message: 'Leave end date cannot be before the start date',
        });
    }
});
export const updateLeaveSchema = z
    .object({
    type: z.enum(LEAVE_TYPES),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    reason: z.string().max(500).nullish(),
})
    .strict()
    .partial();
export const leaveDecisionSchema = z
    .object({ decisionNote: z.string().max(500).optional() })
    .strict();
export const listLeavesQuerySchema = z
    .object({
    userId: objectIdSchema.optional(),
    status: z.enum(LEAVE_STATUSES).optional(),
    /**
     * V10 §6 — more than one status at once.
     *
     * "History" is *decided* requests: approved, rejected and revoked in one
     * chronological list. Three requests stitched together in the client would
     * page independently and interleave wrongly, which is a real bug for a
     * list somebody scrolls to settle an argument.
     */
    statuses: csvOf(z.enum(LEAVE_STATUSES)).optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
    /**
     * V10 §6 — "Upcoming (approved future leaves, **soonest first**)".
     *
     * The default stays newest-first, which is what a queue and a personal
     * history want. Sorting a page in the client would only reorder the page
     * it happened to receive.
     */
    sort: z.enum(['recent', 'soonest']).default('recent'),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
})
    .strict();
export const leaveCalendarQuerySchema = z
    .object({ from: z.coerce.date(), to: z.coerce.date() })
    .strict();
/** How much of a working day each leave type removes (F23). */
export const LEAVE_CAPACITY_FACTOR = {
    leave: 1,
    half_day: 0.5,
    wfh: 0,
};
//# sourceMappingURL=leave.js.map